import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store/app";
import ToolBar from "../../../components/ToolBar";
import { Button } from "antd";
import FilterForm from "./Component/FilterForm";
import ListComponent from "./Component/ListComponent";
import AddComponent from "./Component/AddComponent";
import EditComponent from "./Component/EditComponent";
import BulkAdd from "./Component/BulkAdd";
import DeleteCompanyManagement from "./Component/DeleteCoponent";
import ExportForm from "./Component/ExportForm";
import {
  CompanyNumberDetails,
  getCompaniesList,
  getCompanyNumberManagementList,
} from "../../../store/CompanyNumberManagementSlice";

const CompanyNumberManagement: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const [listData, setListData] = useState<any>();
  const [totalData, setTotalData] = useState<any>(0);
  const [visible, setVisible] = useState<boolean>(false);
  const [savePayload, setSavePayload] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [openCsvModal, setOpenCsvModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editData, setEditData] = useState();
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [openDeleteData, setOpenDeleteData] = useState<any>();
  const [paginationData, setPaginationData] = useState<any>({
    page_number: 1,
    page_size: 10,
  });
  const [companies, setCompanies] = useState<any>([]);
  const getList = useCallback(
    (data?: any) => {
      setLoading(true);

      const payload = {
        ...data,
        page_number: data?.page_number ?? 1,
        page_size: data?.page_size ?? 10,
      };
      setSavePayload(payload);
      dispatch(getCompanyNumberManagementList(payload))
        .then((res: any) => {
          setListData(res?.data?.indexedResults);
          setTotalData(res?.data?.totalRecords);
          setLoading(false);
        })
        .catch(() => {
          setListData([]);
          setTotalData(0);
          setLoading(false);
        });
    },
    [dispatch]
  );

  const openAddModal = () => {
    setVisible(true);
  };

  const closeAddModal = () => {
    setVisible(false);
  };

  const handleCsvModal = () => {
    setOpenCsvModal(true);
  };

  const closeCsvModal = () => {
    setOpenCsvModal(false);
  };

  const getDetailsData = (data: any) => {
    const payload = {
      id: data.main_id,
    };
    dispatch(CompanyNumberDetails(payload))
      .then((res: any) => {
        setEditData(res.data);
        setEditModal(true);
      })
      .catch(() => {
        setEditModal(false);
      });
  };

  const handleEditModal = (data: any) => {
    getDetailsData(data);
  };

  const closeEditModal = () => {
    setEditModal(false);
  };

  useEffect(() => {
    getList();
  }, [getList]);

  const handleDeleteModal = (data: any) => {
    setOpenDeleteModal(true);
    setOpenDeleteData(data);
  };
  const handleDeleteRequestClose = () => {
    setOpenDeleteModal(false);
    setOpenDeleteData(null);
  };
  const [exportDrawer, setOpenDrawer] = useState<boolean>(false);
  const openExportDrawer = () => {
    setOpenDrawer(true);
  };
  const closeExportDrawer = () => {
    setOpenDrawer(false);
  };
  useEffect(() => {
    dispatch(getCompaniesList())
      .then((res: any) => {
        setCompanies(res.data);
      })
      .catch((e: any) => {
        console.warn(e);
      });
  }, [dispatch]);
  return (
    <>
      <ToolBar
        title={"Company Number Management"}
        children={
          <>
            <Button type="primary" onClick={openAddModal}>
              Add New
            </Button>
            <Button type="default" onClick={openExportDrawer}>
              Export
            </Button>
            <Button type="default" onClick={handleCsvModal}>
              Bulk Add
            </Button>
          </>
        }
      />
      <FilterForm
        getList={getList}
        setPaginationData={setPaginationData}
        companies={companies}
      />
      <ListComponent
        listData={listData}
        setListData={setListData}
        totalData={totalData}
        tableloading={loading}
        setTableLoading={setLoading}
        paginationData={paginationData}
        setPaginationData={setPaginationData}
        getList={getList}
        handleEditModal={handleEditModal}
        savePayload={savePayload}
        handleDeleteModal={handleDeleteModal}
      />
      {visible && (
        <AddComponent
          visible={visible}
          close={closeAddModal}
          getList={getList}
          companies={companies}
        />
      )}
      {editModal && (
        <EditComponent
          visible={editModal}
          close={closeEditModal}
          editData={editData}
          getList={getList}
          companies={companies}
        />
      )}
      <BulkAdd close={closeCsvModal} visible={openCsvModal} getList={getList} />
      <DeleteCompanyManagement
        open={openDeleteModal}
        deleteValues={openDeleteData}
        title={openDeleteData?.company_number}
        close={handleDeleteRequestClose}
        name={"Company number"}
        getList={getList}
        setPaginationData={setPaginationData}
        savePayload={savePayload}
      />
      {exportDrawer && (
        <ExportForm visible={exportDrawer} close={closeExportDrawer} savePayload={savePayload}/>
      )}
    </>
  );
};

export default CompanyNumberManagement;
